module.exports = __webpack_public_path__ + "static/media/liebherr100.f048ab4c.pdf";